

import Admin, { hasRole, Role } from '@/models/Admin'
import CreditRepair from '@/models/CreditRepair'

export default class CreditRepairPolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, creditrepair: CreditRepair) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    update(admin: Admin, creditrepair: CreditRepair) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    restore(admin: Admin, creditrepair: CreditRepair) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    delete(admin: Admin, creditrepair: CreditRepair) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    forceDelete(_admin: Admin, _creditrepair: CreditRepair) {
        return false
    }
}
